import React, { useState, useEffect } from 'react';
import './secret-menu-component.css';
import AntaresScrollableTextArea from '../scrollable-text-area/scrollable-text-area.jsx';

/**
 * The secret menu component
 */

const SecretMenu = (props) => {
    const [infos, setInfos] = useState({});

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        }
    }, []);


    useEffect(() => {
        if (JSON.stringify(props.infos) !== JSON.stringify(infos))
            setInfos(props.infos);
    }, [props.infos]);

    const handleKeyDown = (e) => {
        if (e.keyCode === 461 || e.keyCode === 8) {
            if (props.hideSecretMenu)
                props.hideSecretMenu();
        }
    };

    const renderInfos = () => {
        const keys = Object.keys(infos);
        let finalString = ''
        keys.map(key => {
            finalString += `<p>${key} : ${infos[key]}</p>`
        });
        return finalString;
    }

    return (
        <div className='secret-menu-container'>
            <div className='secret-menu-paper'>
                <AntaresScrollableTextArea
                    text={renderInfos()}>
                </AntaresScrollableTextArea>
            </div>
        </div>
    );
}

export default SecretMenu;
